import { render } from "./InterfaceMainMenuItems.vue?vue&type=template&id=5e228a23"
import script from "./InterfaceMainMenuItems.vue?vue&type=script&lang=js"
export * from "./InterfaceMainMenuItems.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__